import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["icon", "className"];
import Component from '../Component';
import Icon from './Icon';
import classList from '../utils/classList';
export default class InfoTile extends Component {
  view(vnode) {
    const _vnode$attrs = vnode.attrs,
      {
        icon,
        className
      } = _vnode$attrs,
      attrs = _objectWithoutProperties(_vnode$attrs, _excluded);
    return m("div", Object.assign({
      className: classList('InfoTile', className)
    }, attrs), this.icon(), m("div", {
      className: "InfoTile-text"
    }, vnode.children));
  }
  icon() {
    if (this.attrs.iconElement) return this.attrs.iconElement;
    if (!this.attrs.icon) return null;
    return m(Icon, {
      name: classList(this.attrs.icon, 'InfoTile-icon')
    });
  }
}
flarum.reg.add('core', 'common/components/InfoTile', InfoTile);